import React from "react";
import { ArrowUpRight } from "lucide-react";
import { specialtyHref } from "../../lib/specialties";

const conditions = [
  {
    slug: "espasticidade",
    title: "Espasticidade",
    desc: "Tônus muscular aumentado após AVC, TCE ou outras condições neurológicas. Tratamento coordenado com reabilitação e fisioterapia.",
  },
  {
    slug: "distonia",
    title: "Distonia",
    desc: "Contrações musculares involuntárias e posturas anormais. Aplicação de Toxina Botulínica em pontos específicos, com plano individualizado.",
  },
  {
    slug: "enxaqueca",
    title: "Enxaqueca",
    desc: "Enxaqueca crônica e dor de cabeça frequente. Avaliação criteriosa dos gatilhos e plano de tratamento personalizado.",
  },
];

export const Conditions = () => {
  return (
    <section
      id="condicoes"
      data-testid="conditions-section"
      className="py-20 sm:py-24 lg:py-32 bg-[#0A2540] text-white relative overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage: "radial-gradient(#D4AF37 1px, transparent 1px)",
          backgroundSize: "28px 28px",
        }}
        aria-hidden
      />
      <div className="relative max-w-7xl mx-auto px-6 sm:px-8">
        <div className="max-w-3xl">
          <p className="overline text-[#D4AF37] mb-5">Condições tratadas</p>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
            Cuidado especializado para cada quadro
          </h2>
          <p className="mt-6 text-white/70 leading-relaxed text-lg">
            Cada paciente recebe um plano individualizado, baseado em avaliação
            clínica detalhada e nas evidências mais recentes.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {conditions.map((c, i) => (
            <a
              key={c.title}
              href={specialtyHref(c.slug)}
              data-testid={`condition-card-${i}`}
              className="group card-lift bg-white/[0.04] border border-white/10 rounded-lg p-8 hover:border-[#D4AF37]/60 hover:bg-white/[0.06] transition-colors flex flex-col"
            >
              <div className="flex items-start justify-between gap-4">
                <h3 className="font-serif-display text-2xl text-white">
                  {c.title}
                </h3>
                <ArrowUpRight
                  className="w-5 h-5 text-[#D4AF37] transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5 flex-shrink-0 mt-1"
                  strokeWidth={1.6}
                />
              </div>
              <p className="text-sm text-white/65 mt-3 leading-relaxed flex-1">
                {c.desc}
              </p>
              <span className="mt-6 text-xs font-semibold uppercase tracking-widest text-[#D4AF37] group-hover:text-[#E5C158] transition-colors">
                Saber mais →
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
